module.exports = __webpack_public_path__ + "img/2019051610554923.88fa1b8b.png";